'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function HRFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement(
      "mask",
      {
        id: "mantine-7m60bjq2q",
        style: { maskType: "alpha" },
        width: "32",
        height: "24",
        x: "0",
        y: "0",
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
    ), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-7m60bjq2q)" }, /* @__PURE__ */ React.createElement("path", { fill: "#F7FCFF", fillRule: "evenodd", d: "M0 0v24h32V0H0z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement(
      "mask",
      {
        id: "mantine-xsx5wn5i5",
        style: { maskType: "alpha" },
        width: "32",
        height: "24",
        x: "0",
        y: "0",
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M0 0v24h32V0H0z", clipRule: "evenodd" })
    ), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-xsx5wn5i5)" }, /* @__PURE__ */ React.createElement("path", { fill: "#E31D1C", fillRule: "evenodd", d: "M0 0v8h32V0H0z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "#3D58DB", fillRule: "evenodd", d: "M0 16v8h32v-8H0z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "#E31D1C", d: "M10.076 6.397h11.4v4h-11.4z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#F7FCFF",
        stroke: "#E31D1C",
        strokeWidth: "1.125",
        d: "M10.652 8.96h10.129c.017.769.022 2.11.022 3.401a638.27 638.27 0 01-.008 2.945v.226l-.001.003a4.943 4.943 0 01-.147.59 5.458 5.458 0 01-.692 1.434c-.694 1.014-1.955 2.056-4.305 2.056-2.347 0-3.547-1.04-4.186-2.045a5.166 5.166 0 01-.738-2.019l-.002-.016v-.045l-.003-.196-.008-.709-.026-2.22c-.015-1.27-.029-2.612-.035-3.405zm.07 6.558s0 0 0 0h0z"
      }
    ), /* @__PURE__ */ React.createElement(
      "mask",
      {
        id: "mantine-3tguppg6p",
        style: { maskType: "alpha" },
        width: "12",
        height: "13",
        x: "10",
        y: "8",
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "#fff",
          stroke: "#fff",
          strokeWidth: "1.125",
          d: "M10.652 8.96h10.129c.017.769.022 2.11.022 3.401a638.27 638.27 0 01-.008 2.945v.226l-.001.003a4.943 4.943 0 01-.147.59 5.458 5.458 0 01-.692 1.434c-.694 1.014-1.955 2.056-4.305 2.056-2.347 0-3.547-1.04-4.186-2.045a5.166 5.166 0 01-.738-2.019l-.002-.016v-.045l-.003-.196-.008-.709-.026-2.22c-.015-1.27-.029-2.612-.035-3.405zm.07 6.558s0 0 0 0h0z"
        }
      )
    ), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-3tguppg6p)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#F50100",
        fillRule: "evenodd",
        d: "M10.498 9.04h2.11v2.142h-2.11V9.04zm4.22 2.142h-2.11v2.142h-2.11v2.142h2.11v2.142h-2.11v2.141h2.11v-2.141h2.11v2.141h2.108v-2.141h2.11v2.141h2.11v-2.141h-2.11v-2.142h2.11v-2.142h-2.11v-2.142h2.11V9.04h-2.11v2.142h-2.11V9.04h-2.109v2.142zm0 2.142v-2.142h2.108v2.142h-2.109zm0 2.142v-2.142h-2.11v2.142h2.11zm2.108 0v2.142h-2.109v-2.142h2.11zm0 0v-2.142h2.11v2.142h-2.11z",
        clipRule: "evenodd"
      }
    )), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#56C6F5",
        fillRule: "evenodd",
        stroke: "#fff",
        strokeWidth: ".5",
        d: "M10.453 8.163s.652-.349 1.209-.528c.556-.18.996-.278.996-.278l-.828-3.052-1.658-.62-.94 1.548 1.221 2.93z",
        clipRule: "evenodd"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M10.181 6.49l.19-.091c.197.42.457.55.812.418.364-.135.511-.392.46-.798l.208-.028c.065.505-.138.857-.595 1.027-.464.174-.834-.012-1.075-.527z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FECA00",
        fillRule: "evenodd",
        d: "M10.632 5.542l-.182.11a.054.054 0 01-.081-.057l.041-.209-.186-.102a.054.054 0 01.008-.1l.202-.068-.005-.213a.054.054 0 01.09-.042l.16.14.183-.11c.04-.024.09.011.081.057l-.041.21.186.102a.054.054 0 01-.008.099l-.202.068.005.213a.054.054 0 01-.09.042l-.16-.14z",
        clipRule: "evenodd"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#56C6F5",
        fillRule: "evenodd",
        stroke: "#fff",
        strokeWidth: ".5",
        d: "M14.54 7.076s.557-.05 1.142-.038c.584.01 1.079.015 1.079.015l.286-3.01-1.253-1.13-1.392 1.157.139 3.006z",
        clipRule: "evenodd"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FECA00",
        fillRule: "evenodd",
        d: "M15.75 6.585c.483 0 .529-.521.529-.876-.124-.197-.099-.338-.494-.338-.396 0-.44.12-.556.338 0 .355.039.876.521.876zm.543-1.472c.482 0 .529-.521.529-.876-.124-.197-.099-.338-.494-.338-.396 0-.44.12-.556.338 0 .355.039.876.521.876zm-1.055 0c.483 0 .529-.521.529-.876-.123-.197-.099-.338-.494-.338s-.44.12-.556.338c0 .355.039.876.521.876z",
        clipRule: "evenodd"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#2E42A5",
        stroke: "#fff",
        strokeWidth: ".5",
        d: "M12.445 7.605l-.072-.245-.867-2.944-.041-.14.1-.104 1.24-1.284.149-.154.175.124 1.363.968.094.067.01.115.252 2.925.023.26-.261.01h0l-.002.001h-.004l-.018.001-.068.003-.233.014a9.107 9.107 0 00-.604.057 5.563 5.563 0 00-.63.143 12.054 12.054 0 00-.336.098l-.02.006-.006.001h0-.001 0l-.243.078zm0 0l.243-.077-.243.077z"
      }
    ), /* @__PURE__ */ React.createElement(
      "mask",
      {
        id: "mantine-canysy5fn",
        style: { maskType: "alpha" },
        width: "5",
        height: "6",
        x: "11",
        y: "2",
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "#fff",
          stroke: "#fff",
          strokeWidth: ".5",
          d: "M12.445 7.605l-.072-.245-.867-2.944-.041-.14.1-.104 1.24-1.284.149-.154.175.124 1.363.968.094.067.01.115.252 2.925.023.26-.261.01h0l-.002.001h-.004l-.018.001-.068.003-.233.014a9.107 9.107 0 00-.604.057 5.563 5.563 0 00-.63.143 12.054 12.054 0 00-.336.098l-.02.006-.006.001h0-.001 0l-.243.078zm0 0l.243-.077-.243.077z"
        }
      )
    ), /* @__PURE__ */ React.createElement("g", { fill: "#C51918", mask: "url(#mantine-canysy5fn)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.436 6.638l-.25-.59c.538-.236 1.447-.38 2.403-.437l.037.642c-.89.052-1.73.184-2.19.385zm-.422-1.428l-.25-.59c.537-.235 1.694-.426 2.65-.482l.037.641c-.89.053-1.978.23-2.437.431z" })), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#2E42A5",
        stroke: "#fff",
        strokeWidth: ".5",
        d: "M18.969 7.607l.068-.252.795-2.949.036-.132-.092-.102-1.168-1.279-.15-.163-.18.128-1.362.968-.095.067-.01.115-.252 2.925-.022.26.261.01h0l.002.001h.004l.018.001.068.003.232.014c.188.012.42.031.605.057.177.025.422.085.63.143a11.92 11.92 0 01.336.098l.02.006.005.001h.002l.249.08zm0 0l-.25-.08.25.08z"
      }
    ), /* @__PURE__ */ React.createElement(
      "mask",
      {
        id: "mantine-9rlrk2lqb",
        style: { maskType: "alpha" },
        width: "5",
        height: "6",
        x: "16",
        y: "2",
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "#fff",
          stroke: "#fff",
          strokeWidth: ".5",
          d: "M18.969 7.607l.068-.252.795-2.949.036-.132-.092-.102-1.168-1.279-.15-.163-.18.128-1.362.968-.095.067-.01.115-.252 2.925-.022.26.261.01h0l.002.001h.004l.018.001.068.003.232.014c.188.012.42.031.605.057.177.025.422.085.63.143a11.92 11.92 0 01.336.098l.02.006.005.001h.002l.249.08zm0 0l-.25-.08.25.08z"
        }
      )
    ), /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd", clipRule: "evenodd", mask: "url(#mantine-9rlrk2lqb)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FECA00",
        d: "M18.398 6.466s.294-.163.336-.439c.043-.276.497-.616.27-.575-.227.04-.097.072-.427 0-.329-.072-.755-.12-.755-.322 0-.203.212-.363.039-.363-.174 0-.543-.192-.469-.045.075.146-.17-.02-.048.284.122.304-.026.61.048.691.075.08-.048.476-.048.476s.045.147.124-.073c.078-.22.25-.374.165-.187-.087.187-.196.632-.098.553a.695.695 0 00.195-.366c0-.073.247-.359.247-.143s-.233.386-.116.386c.116 0 .181.046.254-.17.073-.216.25-.359.324-.216.072.143.056.135-.041.322-.098.187 0 .187 0 .187z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#C51918",
        d: "M17.707 4.867l-.11-.184c.197-.12.377-.153.536-.085.072.03.126.065.268.165l.018.013c.147.103.225.145.273.145v.214c-.11 0-.205-.051-.393-.183l-.019-.013a1.312 1.312 0 00-.229-.144c-.087-.037-.2-.017-.344.072zm-.346 1.396c.062 0 .112-.05.112-.11a.112.112 0 00-.112-.112.112.112 0 00-.113.111c0 .062.05.111.113.111zm.323.104c0 .06-.05.11-.112.11a.112.112 0 01-.113-.11c0-.062.05-.112.113-.112.062 0 .112.05.112.112zm.267.102c.062 0 .112-.05.112-.11a.112.112 0 00-.112-.112.112.112 0 00-.113.111c0 .062.05.111.113.111zm.465.067c0 .061-.05.111-.113.111a.112.112 0 01-.112-.11.112.112 0 01.225-.001z"
      }
    )), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#56C6F5",
        stroke: "#fff",
        strokeWidth: ".5",
        d: "M21.352 8.186l-.108.249-.239-.128h0-.001l-.005-.003-.02-.011a7.39 7.39 0 00-.358-.177 6.985 6.985 0 00-.784-.32 13.041 13.041 0 00-.9-.254l-.056-.013-.014-.003-.003-.001h0l-.26-.058.073-.255.846-2.976.035-.121.118-.044 1.659-.62.194-.072.107.176.94 1.549.066.11-.051.119-1.239 2.853z"
      }
    ), /* @__PURE__ */ React.createElement(
      "mask",
      {
        id: "mantine-b640un4t4",
        style: { maskType: "alpha" },
        width: "5",
        height: "6",
        x: "18",
        y: "3",
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "#fff",
          stroke: "#fff",
          strokeWidth: ".5",
          d: "M21.352 8.186l-.108.249-.239-.128h0-.001l-.005-.003-.02-.011a7.39 7.39 0 00-.358-.177 6.985 6.985 0 00-.784-.32 13.041 13.041 0 00-.9-.254l-.056-.013-.014-.003-.003-.001h0l-.26-.058.073-.255.846-2.976.035-.121.118-.044 1.659-.62.194-.072.107.176.94 1.549.066.11-.051.119-1.239 2.853z"
        }
      )
    ), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-b640un4t4)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FECA00",
        fillRule: "evenodd",
        d: "M21.127 5.09l-.142.158a.054.054 0 01-.094-.03l-.021-.213-.209-.043a.054.054 0 01-.02-.097l.172-.125-.066-.202a.054.054 0 01.073-.067l.195.088.142-.159a.054.054 0 01.094.03l.021.213.209.043c.046.01.059.07.02.097l-.172.125.066.202a.054.054 0 01-.073.066l-.195-.087z",
        clipRule: "evenodd"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#E31D1C",
        d: "M18.995 6.488l.212-.83c.941.249 1.922.567 2.641.875l-.327.79c-.68-.291-1.623-.597-2.526-.835z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M19.283 5.722l.05-.208c.902.224 1.86.58 2.557.913l-.09.194a14.127 14.127 0 00-2.517-.899zm-.267.855l.05-.209a13.04 13.04 0 012.432.86l-.09.194a12.767 12.767 0 00-2.392-.845z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#272727",
        d: "M19.423 6.175l.193-.087c.081.19.182.232.35.15.396-.192 1.38.077 1.38.44 0 .142-.082.228-.208.223a.66.66 0 01-.257-.086 4.297 4.297 0 01-.044-.022 1.315 1.315 0 00-.164-.079l.07-.205c.045.017.052.02.188.09l.042.02a.543.543 0 00.173.065c.003 0-.011.015-.011-.006 0-.16-.8-.379-1.08-.243-.277.134-.504.04-.632-.26z"
      }
    )))))
  );
}

export { HRFlag };
//# sourceMappingURL=HR.mjs.map
